/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_PropertyInputs */

const cs_col_property = /** @type {(inputs: Col_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost`)
};

const en_col_property = /** @type {(inputs: Col_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property`)
};

/**
* | output |
* | --- |
* | "Property" |
*
* @param {Col_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_property = /** @type {((inputs?: Col_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_property(inputs)
	return cs_col_property(inputs)
});